.rowAction {
  display: inline-flex;

  > a,
  > button {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    &:focus {
      outline: none;
    }

    &:focus-visible {
      box-shadow:
        inset 0 0 1px var(--ixf-text-tone-md),
        inset 0 0 1px var(--ixf-text-tone-md),
        inset 0 0 1px var(--ixf-text-tone-md),
        inset 0 0 1px var(--ixf-text-tone-md);
    }
  }
}
